import {TenantInviteeRole} from "../../services/GeneratedApiTsClient";

export const TenantInviteeRoleNames: {value: TenantInviteeRole, label:string}[] = [
    {value: TenantInviteeRole.GUEST, label: "Guest"},
    {value: TenantInviteeRole.COLLABORATOR, label: "Collaborator"},
    {value: TenantInviteeRole.OWNER, label: "Owner"},
]